import React from 'react';
import Indicator from './Indicator';
import { ImagesPropType } from '../../../services/proptypes';
export default function IndicatorGroup(_ref) {
  var images = _ref.images,
    currentIndex = _ref.currentIndex,
    changeCurrentIndex = _ref.changeCurrentIndex;
  return /*#__PURE__*/React.createElement(React.Fragment, null, images.map(function (image, index) {
    return /*#__PURE__*/React.createElement(Indicator, {
      index: index,
      currentIndex: currentIndex,
      changeCurrentIndex: changeCurrentIndex
    });
  }));
}